import { Trash2 } from "lucide-react";

export default function AdminRfqsTab({ rfqs, onDelete, t }) {
  return (
    <div className="tech-card overflow-hidden" data-testid="admin-rfqs">
      {rfqs.length === 0 ? <div className="p-8 text-center text-slate-500 text-sm">{t("admin.noRfqs")}</div> : (
        <div className="divide-y divide-slate-800">
          {rfqs.map((r) => (
            <div key={r.id} className="px-4 py-3 flex items-center gap-3" data-testid={`admin-rfq-${r.id}`}>
              <div className="flex-1 min-w-0">
                <div className="font-display font-medium text-slate-100">{r.title}</div>
                <div className="text-xs text-slate-500 truncate">{r.workshop_name} · {r.material} · qty {r.quantity} · {r.offer_count} {t("admin.offersReceived").toLowerCase()}</div>
              </div>
              <div className="text-xs text-slate-500">{new Date(r.created_at).toLocaleDateString()}</div>
              <button onClick={() => onDelete(r.id)} className="p-2 rounded text-slate-500 hover:text-red-400 hover:bg-red-500/10" data-testid={`admin-delete-rfq-${r.id}`}>
                <Trash2 size={14}/>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
